'use strict';

angular.module('DoohApps').service('MediaScreenBLL', ['ScreensData', 'MediaDevicesData', 'SoftwareHardwareComplianceData', 'Admin', 'FileUpload', 'UploadFileStorage', 'FileDownloadHelper',
    function (ScreensData, MediaDevicesData, SoftwareHardwareComplianceData, Admin, FileUpload, UploadFileStorage, FileDownloadHelper) {
        this.GetMediaScreenList = function (callback, filter) {
            MediaDevicesData.getMediaScreenList(function (data) { returnContent(callback, data) }, filter);
        };

        this.GetScreenByMediaId = function (callback, mediaId) {
            MediaDevicesData.getScreenByMediaId(function (data) { returnContent(callback, data) }, mediaId);
        };

        this.SendScreenShotUpdateRequest = function (callback, mediaId) {
            MediaDevicesData.sendScreenShotUpdateRequest(function (data) { responseHandler(callback, data) }, mediaId);
        };

        this.SendSystemInfoUpdateRequest = function (callback, mediaId) {
            MediaDevicesData.sendSystemInfoUpdateRequest(function (data) { responseHandler(callback, data) }, mediaId);
        };

        this.LoadLog = function (callback, filter) {
            MediaDevicesData.getMediaDeviceLog(function (data) { responseHandler(callback, data) }, filter);
        };

        this.DownloadLog = function (filter) {
            FileDownloadHelper.downloadFile(MediaDevicesData.getDownloadLogUrl(filter));
        };

        this.LoadSettings = function (callback, MediaDeviceId) {
            MediaDevicesData.loadSettings(function (data) {
                returnContent(callback, data)
            }, MediaDeviceId);
        };

        this.UpdateSettings = function (callback, settings) {
            MediaDevicesData.updateSettings(function (data) {
                callback(data)
            }, settings);
        }
        this.GetScreenConfigs = function (callback) {
            ScreensData.getScreenConfigs(function (data) { returnContent(callback, data) });
        };

        this.GetScreenConfigDetails = function (screenConfigDetails, mediaId) {
            ScreensData.getScreenConfigDetails(screenConfigDetails, mediaId);
        };

        this.updateScreenDetails = function (callback, dataObject) {
            ScreensData.updateScreenDetails(function (data) { responseHandler(callback, data) }, dataObject);
        };

        function returnContent(callback, data) {
            callback(data.Data.Content);
        };

        this.compareDeviceColors = function (callback, deviceColorData) {
            ScreensData.compareDeviceColors(function (data) { responseHandler(callback, data) }, deviceColorData);
        };

        function responseHandler(callback, data) {
            callback({
                hasError: data.hasError || (data.Data != undefined && data.Data.error != undefined) || data.error != undefined || data.error_description != undefined,
                error: getErrorMessage(data),
                message: data.message || (data.Data != undefined ? data.Data.message : null),
                content: (data.Data != undefined) ? ((data.Data.Content != undefined) ? data.Data.Content : {}) : {}
            });
        }

        function getErrorMessage(data) {
            if (data.hasError)
                return data.errors[0];

            return data.error_description || data.error || (data.Data != undefined ? data.Data.error : null);
        }

        this.GetScreenConfigsForCompany = function (callback, filer) {
            ScreensData.getScreenConfigsForCompany(function (data) { returnContent(callback, data) }, filer);
        };

        this.createConfig = function (callback, config) {
            SoftwareHardwareComplianceData.addCompliance(function (data) { callback(data) }, config);
        }

        this.checkMatchcode = function (callback, code) {
            SoftwareHardwareComplianceData.checkMatchcode(function (data) { callback(data) }, escape(code));
        }

        this.deleteDeviceComplianceGroup = function (callback, groupID) {
            SoftwareHardwareComplianceData.deleteCompliance(function (data) { callback(data) }, groupID);
        }

        this.updateCompliance = function (callback, updateData) {
            SoftwareHardwareComplianceData.updateCompliance(function (data) { callback(data) }, updateData);
        }

        this.newVirtualDevice = function (callback, device) {
            ScreensData.newVirtualDevice(function (data) { callback(data) }, device);
        }

        this.forceUpdate = function (callback, mediaId) {
            MediaDevicesData.ForceUpdate(function (data) { callback(data) }, mediaId);
        }

        this.deleteMediaDevice = function (callback, id) {
            MediaDevicesData.deleteMediaDevice(function (data) { callback(data) }, id);
        }

        this.getCompaniesUsingCompliance = function (callback, Id) {
            SoftwareHardwareComplianceData.getCompaniesUsingCompliance(function (data) { callback(data) }, Id);
        }

        this.getDeviceRelatedCount = function (callback, mediaID) {
            Admin.getDeviceRelatedCount(function (data) { responseHandler(callback, data) }, mediaID);
        }

        this.moveDevice = function (callback, moveDevOptions) {
            Admin.moveDevice(function (data) { responseHandler(callback, data) }, moveDevOptions);
        }

        this.getScreenList = function (callback, companyid) {
            Admin.getScreenList(function (data) { responseHandler(callback, data) }, companyid);
        }

        this.regenerateDeviceKey = function (callback, deviceID) {
            MediaDevicesData.regenerateDeviceKey(function (data) { callback(data) }, deviceID);
        }

        this.SaveTransitionLogo = function (onProgress, onSuccess, onError, companyId) {
            var files = UploadFileStorage.GetFiles();
            var uploadUrlReceivedHandler = createFileUploadUrlReceivedHandler(files[0], onProgress, onSuccess, onError, companyId);
            if (files[0].type.indexOf('text') == -1) {
                FileUpload.getFileUploadUrl(uploadUrlReceivedHandler, encodeURIComponent(files[0].name), companyId);
            }
        }

        function createFileUploadUrlReceivedHandler(file, onProgress, onSuccess, onError, companyId) {
            return function (url, token) {
                FileUpload.upload({
                    file,
                    url,
                    token,
                    onProgress,
                    onSuccess,
                    onError,
                    companyId
                });
            }
        }

        this.updateTransitionLogo = function (callback, logoDTO) {
            MediaDevicesData.updateTransitionLogo(function (data) {
                responseHandler(callback, data);
            }, logoDTO);
        }

        this.deleteTransitionLogo = function (callback, companyID, deviceID, groupID) {
            MediaDevicesData.deleteTransitionLogo(function (data) {
                responseHandler(callback, data);
            }, companyID, deviceID, groupID);
        }

        this.GetDevices = function (callback, filter) {
            MediaDevicesData.GetDevices(function (data) { responseHandler(callback, data) }, filter);
        };

        this.GetDevicesInGroup = function (callback, filter) {
            MediaDevicesData.GetDevicesInGroup(function (data) { responseHandler(callback, data) }, filter);
        };

        this.GetDeviceGroups = function (callback, filter) {
            MediaDevicesData.GetDeviceGroups(function (data) { responseHandler(callback, data) }, filter);
        };

        this.CreateDeviceGroup = function (callback, data) {
            MediaDevicesData.createDeviceGroup(function (data) { responseHandler(callback, data) }, data);
        };

        this.GetGroupConfigDetails = function (callback, groupID) {
            MediaDevicesData.getGroupConfigDetails(function (data) { responseHandler(callback, data) }, groupID);
        };
        this.updateGroupDetails = function (callback, dataObject) {
            MediaDevicesData.updateGroupDetails(function (data) { responseHandler(callback, data) }, dataObject);
        };

        this.GetNotAddedDevicesForGroup = function (callback, groupID) {
            MediaDevicesData.getNotAddedDevicesForGroup(function (data) { responseHandler(callback, data) }, groupID);
        };
        this.AddRemoveDevicesToGroup = function (callback, data) {
            MediaDevicesData.AddRemoveDevicesToGroup(function (data) { responseHandler(callback, data) }, data);
        }
        this.GetMediaDeviceGroupSettings = function (callback, groupID) {
            MediaDevicesData.getMediaDeviceGroupSettings(function (data) { responseHandler(callback, data) }, groupID);
        };
        this.updateGroupSettings = function (callback, settings) {
            MediaDevicesData.updateGroupSettings(function (data) {
                responseHandler(callback, data)
            }, settings);
        }
        this.deleteDeviceGroup = function (callback, id) {
            MediaDevicesData.deleteDeviceGroup(function (data) { responseHandler(callback, data) }, id);
        }
        this.getAppDeviceMissingLicenses = function (callback, groupID, mediaDevIDs) {
            MediaDevicesData.getAppDeviceMissingLicenses(function (data) { responseHandler(callback, data) }, groupID, mediaDevIDs);
        }
        this.checkDeviceGroupSchedule = function (callback, groupID) {
            MediaDevicesData.checkDeviceGroupSchedule(function (data) { responseHandler(callback, data) }, groupID);
        }

        this.RequestDeviceRestart = function (callback, mediaId) {
            MediaDevicesData.requestDeviceRestart(function (data) { responseHandler(callback, data) }, mediaId);
        }
    }]);